import transitions, {
    TransitionViewRenderers,
    TransitionViewNames,
    TransitionDirection,
} from './actions/transitions';

export function animateInAlmostDone (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.ALMOST_DONE_VIEW);
    astore.setRenderer(TransitionViewRenderers.ALMOST_DONE_VIEW);
    env.appStore.gotoAlmostDone();
}

export function animateInSuccess (env) {
    if (window.location.pathname.indexOf('/success') !== -1) {
        return;
    }
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.SUCCESS_VIEW);
    astore.setRenderer(TransitionViewRenderers.SUCCESS_VIEW);
    env.appStore.gotoSuccessInfo();
}

export function animateInHavingTrouble (env) {
    if (window.location.pathname.indexOf('/havingtrouble') !== -1) {
        return;
    }
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.HAVING_TROUBLE_VIEW);
    astore.setRenderer(TransitionViewRenderers.HAVING_TROUBLE_VIEW);
    env.appStore.gotoHavingTrouble();
}

export function animateOauthLoading (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.OAUTH_LOADING_VIEW);
    astore.setRenderer(TransitionViewRenderers.OAUTH_LOADING_VIEW);
    env.appStore.gotoOauthLoading();
}

export function animateOauthFailed (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.BACK,
    });
    astore.setIncomingView(TransitionViewNames.CALENDARS_VIEW);
    astore.setRenderer(TransitionViewRenderers.CALENDARS_VIEW);
    env.appStore.gotoCalendarApps();
}

export function animateInSubscriberForm (env) {
    const astore = env.animationsStore;
    astore.setIncomingView(TransitionViewNames.SUBSCRIBER_VIEW);
    astore.setRenderer(TransitionViewRenderers.SUBSCRIBER_VIEW);
    env.appStore.gotoSubscriberForm();
}

export function animateOauthLauncherPage (env) {
    const astore = env.animationsStore;
    astore.setIncomingView(TransitionViewNames.OAUTH_LAUNCHER_VIEW);
    astore.setRenderer(TransitionViewRenderers.OAUTH_LAUNCHER_VIEW);
    env.appStore.launchOauthPage();
}

export function animateOutOauthLauncherPage (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.SUCCESS_VIEW);
    astore.setRenderer(TransitionViewRenderers.SUCCESS_VIEW);
}

export function animateInICSLink (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.ICSLINK_VIEW);
    astore.setRenderer(TransitionViewRenderers.ICSLINK_VIEW);
    env.appStore.gotoICSLink();
}

export function animateInICSOutlook (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.ICSLINK_OUTLOOK_VIEW);
    astore.setRenderer(TransitionViewRenderers.ICSLINK_OUTLOOK_VIEW);
    env.appStore.gotoICSLinkOutlook();
}

export function animateInInAppGuide (env) {
    const astore = env.animationsStore;
    astore.setTransitionsProps({
        animationIn: transitions.slideInFromNext,
        animationOut: transitions.slideOutToBack,
        direction: TransitionDirection.NEXT,
    });
    astore.setIncomingView(TransitionViewNames.INAPP_GUIDE_VIEW);
    astore.setRenderer(TransitionViewRenderers.INAPP_GUIDE_VIEW);
    env.appStore.gotoInAppGuide();
}
